import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeAllStatesList } from './normalize';

export const fetchAllStatesList = createProvider(api.fetchAllStatesList)
  .andThen((res) => normalizeAllStatesList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
